<template lang="pug">
.aside-layout.content-container
  .main-container
    slot(name="main")
  .aside-container
    slot(name="aside")
  .extend-container
    slot(name="extend")
</template>

<script>

export default {
  name: "AsideLayout",
}
</script>

<style lang="scss" scoped>
.aside-layout{
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  .main-container{
    width: 848px;
  }
  .aside-container{
    width: 416px;
    ::v-deep .aside-section{
      & + .aside-section{
        margin-top: 14px;
      }
    }
  }
}
</style>
